import { NoteSourceArtifactInfo } from "@/components/note/editor/source-bar/types";
import { normalizeTranscriptEntries } from "@/components/note/floating-actions/audio-capture/audio-capture-actions.source";
import { MDSBubbleVariant } from "@/mds";
import { copyTextToClipboard } from "@/modules/clipboard/copyTextToClipboard";
import { toastModule } from "@/modules/toast";
import { AudioRecordingObservable } from "@/store/audio-recordings";

export const copyRecordingTranscript = async ({
  recording,
}: {
  recording: AudioRecordingObservable | null;
}) => {
  if (!recording || !recording.transcriptTurns.length) return;

  const entries = normalizeTranscriptEntries(recording.transcriptTurns);
  const transcript = entries
    .filter(t => t.text.trim())
    .map(t => `[${t.variant === MDSBubbleVariant.VoiceOthers ? "Others" : "Me"}] ${t.text}`)
    .join("\n");

  await copyTextToClipboard({ text: transcript });

  toastModule.triggerToast({ content: "Transcript copied to clipboard" });
};

export const copyNoteTranscript = async ({
  artifactInfo,
}: {
  artifactInfo: NoteSourceArtifactInfo;
}) => {
  if (artifactInfo?.kind !== "AUDIO" || !artifactInfo.data) return;

  const transcript =
    artifactInfo.data.transcript_array
      ?.filter(t => t.transcript?.trim())
      ?.map(t => `[${t.channel ? "Others" : "Me"}] ${t.transcript}`)
      .join("\n") || artifactInfo.data.transcript_text;
  if (!transcript) return;

  await copyTextToClipboard({ text: transcript });

  toastModule.triggerToast({ content: "Transcript copied to clipboard" });
};
